import jApi from './jApi';

// temporary data
const request = {
  pagination: {
    limit: 0,
    page: 0,
    column: '',
    ascending: false,
  },
};

export default {
  listUser(req) {
    const api = jApi.generateApi();
    if (req) {
      return api.post('user/studio/employee/list', req)
        .then(res => res.data.data);
    }
    return api.post('user/studio/employee/list', request)
      .then(res => res.data.data);
  },

  emailId(req) {
    const api = jApi.generateApi();
    return api.post('user/employee/detail-by-email', req)
      .then(res => res.data);
  },

  userAuthorize() {
    const api = jApi.generateApi();
    return api.get('user/authorize')
      .then(res => res.data);
  },

  listOrganigram(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/organigram/list', req)
      .then(res => res);
  },

  listUserPagination(req) {
    const api = jApi.generateApi();
    return api.post('user/employee/list-with-pagination', req)
      .then(res => res);
  },

  listUserByIds(req) {
    const api = jApi.generateApi();
    return api.post('user/employee/list/filter-status', req)
      .then(res => res.data);
  },

  getUserRestrictionMonitor(req) {
    const api = jApi.generateApi();
    return api.post('times/user-restriction/monitor', req)
      .then(res => res);
  },

  getUserRestrictionReport(req) {
    const api = jApi.generateApi();
    return api.post('times/user-restriction/report', req)
      .then(res => res);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiUser.js